import React from 'react'

const Wishlist = () => {
  return (
    <div><h3>WishList</h3><p>Your saved items.</p></div>
  )
}

export default Wishlist